export const structuredData = {
  "@context": "http://schema.org",
  "@type": "SoftwareApplication",
  applicationCategory: "BusinessApplication",
  url: "https://qrcodecreator.com/",
  operatingSystem: "Cross-platform",
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": "https://qrcodecreator.com/",
  },
  headline: "QR Code Creator",
  description: "Free QR Code Generator Online",
};

export const descriptionDefault =
  "QR Code Creator for Wi-fi,Location,Social media,URL,vCard,Text,email,sms,images,phone,pdf,word,and more. Add sticker , logo, colors, frames, shapes and download in high print quality. Get your free QR Codes now! qrcodecreator Qr Code Creator qrcode qr code";

export const keywordDefault =
  "Qrcode , qrcode , qr code , barcode , wi-fi , social , creator , generator , bestqrcode , best qrcode";
 